/* eslint-disable indent */
import { useState, useEffect } from 'react';
import { Box, Typography, Container, useTheme, Button } from '@mui/material';


import SliderInfluencersImage1 from '../../assets/sliderInfluencers/sliderInfluencersImage1.png';
import SliderInfluencersImage2 from '../../assets/sliderInfluencers/sliderInfluencersImage2.png';
import SliderInfluencersImage3 from '../../assets/sliderInfluencers/sliderInfluencersImage3.png';
import SliderInfluencersImage4 from '../../assets/sliderInfluencers/sliderInfluencersImage4.png';
import SliderInfluencersImage5 from '../../assets/sliderInfluencers/sliderInfluencersImage5.png';
import SliderInfluencersImage6 from '../../assets/sliderInfluencers/sliderInfluencersImage6.png';

import ListPersonaBtn from './SLPInfluencersListPersonaBtn';

const heroImages = [SliderInfluencersImage1, SliderInfluencersImage2, SliderInfluencersImage3,SliderInfluencersImage4,SliderInfluencersImage5,SliderInfluencersImage6];

export const SLPInfluencersHero = () => {
  const theme = useTheme();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % heroImages.length);
        setFade(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleScrollToSLPInfluencersHow = () => {
    const element = document.getElementById('slp-influencers-how');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
    <Box
      sx={{
        width: '100%',
        height: '88vh',
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
          height: '20vh',
        }
      }}
    >
      {/* Background Image with Fade Effect */}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundImage: `url(${heroImages[currentImageIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'opacity 0.8s ease-in-out',
          opacity: fade ? 1 : 0,
          zIndex: 1,
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(60deg, rgba(0, 0, 0, 0.9) 27%, transparent 80%)',
            pointerEvents: 'none'
          }
        }}
      />

            {/* Mobile Title */}
      <Typography
        variant="h2"
        component="h1"
        sx={{
          display: { xs: 'block', md: 'none' }, // Only on mobile
          position: 'absolute',
          bottom: '62.8px',
          left: '1rem',
          right: '1rem',
          zIndex: 2,
          color: '#ffffff',
          fontWeight: 400,
          fontSize: '20px',
          fontFamily: 'Inter',
          lineHeight: '130%',
          textAlign: 'center',
          
          
        }}
      >
        Your Persona.<br />Your Rules. Your Earnings.
      </Typography>

      {/* Foreground Content */}
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          height: '100%',
          zIndex: 2,
          display: 'flex',
          alignItems: 'end',
          [theme.breakpoints.down('md')]: {
            display:"none",
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            marginBottom: '83px',
            px: 5,
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            width="452px"
            fontFamily="Inter"
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: { xs: '1.5rem', sm: '1.5rem', md: '28px' },
              lineHeight: '120%',
              color: '#ffffff',

              mb: 1,
            }}
          >
            Your Persona. Your Rules. Your Earnings.{' '}
          </Typography>
          <Box>
            <Typography
              sx={{
                fontWeight: 300,
                color: '#C0C0C0',
                ffontSize: { xs: '1rem', sm: '1rem', md: '16px' },
                fontFamily: 'Inter',
                width: '524px',

                lineHeight: '120%'
              }}
            >
              Saagas helps you license your Persona (name, image, likeness, and voice — NILV) to vetted brands and agencies. Choose AI-powered content generation or traditional UGC production — your workflow, your call. Set your fees, approve each campaign, and get paid when your Persona is used.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'nowrap', // This ensures buttons stay side by side
            }}
          >
            <Button
              sx={{
                fontFamily: 'Inter',
                maxHeight: '52px',
                maxWidth: '319px',
                marginTop: '5px',
                color: '#fff',
                fontWeight: 600,
                fontSize: '16.8px',
                padding: '16px 24px',
                borderRadius: '999px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                backgroundColor: 'transparent',
                textTransform: 'none',
                transition: 'all 0.3s ease-in-out',
                whiteSpace: 'nowrap', // Prevents wrapping
                overflow: 'hidden', // Hides overflow
                textOverflow: 'ellipsis', // Adds '...' if text overflows
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.8)'
                }
              }}
              onClick={handleScrollToSLPInfluencersHow}
            >
              See how Persona licensing works
            </Button>

            <ListPersonaBtn maxHeight="52px" maxWidth="200px" marginTop="4px" />
          </Box>
        </Box>
      </Container>
    </Box>

    {/* Mobile Content Section - Black Background */}
    <Box
      sx={{
        display: 'none',
        [theme.breakpoints.down('md')]: {
          display: 'flex',
          backgroundColor: '#000000',
          padding: '2rem 1.5rem 10 1.5rem',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2.5rem',
          alignItems: 'center',
          textAlign: 'center',
          maxWidth: '600px',
          width: '100%',
           px: { xs: '10px', sm: '15px' },
            mt: '40px',
        }}
      >
        <Typography
          sx={{
            fontWeight: 300,
            color: '#C0C0C0',
            fontSize: '16px',
            fontFamily: 'Inter',
            lineHeight: '140%',
            // mx: '44px',
            // mt: '40px',
            width : '302px'

          }}
        >
          Saagas helps you license your Persona (name, image, likeness, and voice — NILV) to vetted brands and agencies. Choose AI-powered content generation or traditional UGC production — your workflow, your call. Set your fees, approve each campaign, and get paid when your Persona is used.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            flexDirection: 'column',
            alignItems: 'center',
            flexWrap: 'nowrap',
            width: '100%'
          }}
        >
          <Button
            sx={{
              width: '100%',
              maxWidth: '274px',
              color: '#fff',
              fontWeight: 600,
              fontSize: '14px',
              padding: { xs: '12px 16px', md: '16px 24px' },
              borderRadius: '999px',
              border: '1px solid rgba(255, 255, 255, 0.5)',
              backgroundColor: 'transparent',
              fontFamily: 'Inter',
              textTransform: 'none',
              transition: 'all 0.3s ease-in-out',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.8)'
              }
            }}
            onClick={handleScrollToSLPInfluencersHow}
          >
            See how Persona licensing works
          </Button>
          <Box sx={{ width: '100%', maxWidth: '164px' }}>
            <ListPersonaBtn maxHeight="52px" maxWidth="100%" marginTop="0" />
          </Box>
        </Box>
      </Box>
    </Box>
    </>
  );
};
